import useAuthStore from "store/authStore";

const useRoles = () => {
	const { hasRoles } = useAuthStore();

	const roles = [];

	if (hasRoles(["Super Administrator"])) {
		roles.push(
			{ label: "Administrator", value: "Administrator" },
			{ label: "Senior Publisher", value: "Senior Publisher" },
			{ label: "Publisher", value: "Publisher" },
			{ label: "Institution", value: "Institution" },
			{ label: "Educator", value: "Educator" },
			{ label: "Student", value: "Student" },
			{ label: "Individual", value: "Individual" },
			{ label: "Super Administrator", value: "Super Administrator" }
		);
	} else if (hasRoles(["Administrator"])) {
		roles.push(
			{ label: "Administrator", value: "Administrator" },
			{ label: "Senior Publisher", value: "Senior Publisher" },
			{ label: "Publisher", value: "Publisher" },
			{ label: "Institution", value: "Institution" },
			{ label: "Educator", value: "Educator" },
			{ label: "Student", value: "Student" },
			{ label: "Individual", value: "Individual" }
		);
	} else if (hasRoles(["Senior Publisher"])) {
		roles.push(
			{ label: "Senior Publisher", value: "Senior Publisher" },
			{ label: "Publisher", value: "Publisher" }
		);
	} else if (hasRoles(["Publisher"])) {
		roles.push({ label: "Publisher", value: "Publisher" });
	} else if (hasRoles(["Institution"])) {
		roles.push(
			{ label: "Institution", value: "Institution" },
			{ label: "Educator", value: "Educator" },
			{ label: "Student", value: "Student" }
		);
	} else if (hasRoles(["Educator"])) {
		roles.push({ label: "Educator", value: "Educator" });
	} else if (hasRoles(["Student"])) {
		roles.push({ label: "Student", value: "Student" });
	}

	return { roles };
};

export default useRoles;
